import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="75" cy="75" r="75" fill="url(#paint01_radial)"/>
        <defs>
            <radialGradient id="paint01_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(75 75) rotate(90) scale(75)">
                <stop stopColor="#1A98FF"/>
                <stop offset="1" stopColor="#1A98FF" stopOpacity="0"/>
            </radialGradient>
        </defs>
    </svg>
)
